// FICHIER GÉNÉRÉ par scripts/gen-catalog.ts depuis docs/TANKSHIFT_Dossier.md — ne pas éditer à la main.
export interface RawClassNode { id: string; family: string; name: string; parent: string; level: number; desc: string }
export interface RawMod { id: string; kind: 'weapon' | 'chassis' | 'passive'; group: string; name: string; desc: string }
export interface RawPassLevel { level: number; free: string; premium: string }

export const RAW_CLASSES: RawClassNode[] = [
 {
  "id": "C01-F",
  "family": "Assaut",
  "name": "Avant-garde",
  "parent": "BASE",
  "level": 10,
  "desc": "canon polyvalent, aucune spécialité dominante"
 },
 {
  "id": "C01-A",
  "family": "Assaut",
  "name": "Double",
  "parent": "C01-F",
  "level": 25,
  "desc": "deux canons alternés, précision réduite"
 },
 {
  "id": "C01-B",
  "family": "Assaut",
  "name": "Rafale",
  "parent": "C01-F",
  "level": 30,
  "desc": "salves courtes, pause entre salves"
 },
 {
  "id": "C01-C",
  "family": "Assaut",
  "name": "Rotatif",
  "parent": "C01-F",
  "level": 35,
  "desc": "cadence croissante, chauffe"
 },
 {
  "id": "C01-A1",
  "family": "Assaut",
  "name": "Quadruple",
  "parent": "C01-A",
  "level": 50,
  "desc": "quatre tubes alternés, dispersion élevée"
 },
 {
  "id": "C01-A2",
  "family": "Assaut",
  "name": "Croisé",
  "parent": "C01-A",
  "level": 60,
  "desc": "deux paires obliques, angle mort axial"
 },
 {
  "id": "C01-B1",
  "family": "Assaut",
  "name": "Percuteur",
  "parent": "C01-B",
  "level": 50,
  "desc": "salve serrée, fort recul"
 },
 {
  "id": "C01-B2",
  "family": "Assaut",
  "name": "Tambour",
  "parent": "C01-B",
  "level": 60,
  "desc": "longue rafale, rechargement long"
 },
 {
  "id": "C01-C1",
  "family": "Assaut",
  "name": "Vulcain",
  "parent": "C01-C",
  "level": 50,
  "desc": "très haute cadence, portée réduite"
 },
 {
  "id": "C01-C2",
  "family": "Assaut",
  "name": "Cyclone",
  "parent": "C01-C",
  "level": 60,
  "desc": "tir tournant large, faible concentration"
 },
 {
  "id": "C02-F",
  "family": "Précision",
  "name": "Éclaireur",
  "parent": "BASE",
  "level": 10,
  "desc": "tir rapide et précis, cadence faible"
 },
 {
  "id": "C02-A",
  "family": "Précision",
  "name": "Sniper",
  "parent": "C02-F",
  "level": 25,
  "desc": "portée longue, faible mobilité au tir"
 },
 {
  "id": "C02-B",
  "family": "Précision",
  "name": "Chargeur",
  "parent": "C02-F",
  "level": 30,
  "desc": "tir chargé au maintien, vulnérable entre tirs"
 },
 {
  "id": "C02-C",
  "family": "Précision",
  "name": "Antimatériel",
  "parent": "C02-F",
  "level": 35,
  "desc": "balle lourde, rotation lente"
 },
 {
  "id": "C02-A1",
  "family": "Précision",
  "name": "Longue-vue",
  "parent": "C02-A",
  "level": 50,
  "desc": "portée maximale, faible défense latérale"
 },
 {
  "id": "C02-A2",
  "family": "Précision",
  "name": "Aiguille",
  "parent": "C02-A",
  "level": 60,
  "desc": "tir étroit perforant, visée exigeante"
 },
 {
  "id": "C02-B1",
  "family": "Précision",
  "name": "Rail",
  "parent": "C02-B",
  "level": 50,
  "desc": "ligne perçante annoncée, charge longue"
 },
 {
  "id": "C02-B2",
  "family": "Précision",
  "name": "Condensateur",
  "parent": "C02-B",
  "level": 60,
  "desc": "charge modulable, surchauffe rapide"
 },
 {
  "id": "C02-C1",
  "family": "Précision",
  "name": "Briseur",
  "parent": "C02-C",
  "level": 50,
  "desc": "dégâts contre plaques, faible cadence"
 },
 {
  "id": "C02-C2",
  "family": "Précision",
  "name": "Contrepoids",
  "parent": "C02-C",
  "level": 60,
  "desc": "tir puissant qui repousse son tank, trajectoire difficile"
 },
 {
  "id": "C03-F",
  "family": "Artillerie",
  "name": "Obusier",
  "parent": "BASE",
  "level": 10,
  "desc": "obus lents en cloche visuelle, impact télégraphié"
 },
 {
  "id": "C03-A",
  "family": "Artillerie",
  "name": "Mortier",
  "parent": "C03-F",
  "level": 25,
  "desc": "tire au point visé, zone minimale de sécurité"
 },
 {
  "id": "C03-B",
  "family": "Artillerie",
  "name": "Bombardier",
  "parent": "C03-F",
  "level": 30,
  "desc": "obus fragmentés, impact central réduit"
 },
 {
  "id": "C03-C",
  "family": "Artillerie",
  "name": "Siège",
  "parent": "C03-F",
  "level": 35,
  "desc": "explosion large, forte lenteur"
 },
 {
  "id": "C03-A1",
  "family": "Artillerie",
  "name": "Barrage",
  "parent": "C03-A",
  "level": 50,
  "desc": "trois impacts successifs, longs délais"
 },
 {
  "id": "C03-A2",
  "family": "Artillerie",
  "name": "Météore",
  "parent": "C03-A",
  "level": 60,
  "desc": "obus unique massif, avertissement visible"
 },
 {
  "id": "C03-B1",
  "family": "Artillerie",
  "name": "Grappe",
  "parent": "C03-B",
  "level": 50,
  "desc": "sous-munitions non récursives, dégâts divisés"
 },
 {
  "id": "C03-B2",
  "family": "Artillerie",
  "name": "Éventail",
  "parent": "C03-B",
  "level": 60,
  "desc": "fragments en cône, faible portée"
 },
 {
  "id": "C03-C1",
  "family": "Artillerie",
  "name": "Forteresse",
  "parent": "C03-C",
  "level": 50,
  "desc": "longue portée en mouvement lent, vulnérable proche"
 },
 {
  "id": "C03-C2",
  "family": "Artillerie",
  "name": "Démolisseur",
  "parent": "C03-C",
  "level": 60,
  "desc": "gros impact anti-groupes, recharge très longue"
 },
 {
  "id": "C04-F",
  "family": "Missiles",
  "name": "Lanceur",
  "parent": "BASE",
  "level": 10,
  "desc": "roquette directe, projectile destructible"
 },
 {
  "id": "C04-A",
  "family": "Missiles",
  "name": "Traqueur",
  "parent": "C04-F",
  "level": 25,
  "desc": "guidage vers visée, virage limité"
 },
 {
  "id": "C04-B",
  "family": "Missiles",
  "name": "Salve",
  "parent": "C04-F",
  "level": 30,
  "desc": "plusieurs roquettes, dégâts unitaires faibles"
 },
 {
  "id": "C04-C",
  "family": "Missiles",
  "name": "Torpilleur",
  "parent": "C04-F",
  "level": 35,
  "desc": "roquette lente lourde, interception facile"
 },
 {
  "id": "C04-A1",
  "family": "Missiles",
  "name": "Poursuivant",
  "parent": "C04-A",
  "level": 50,
  "desc": "poursuite courte, avertissement cible"
 },
 {
  "id": "C04-A2",
  "family": "Missiles",
  "name": "Virage",
  "parent": "C04-A",
  "level": 60,
  "desc": "missile courbe contrôlé par visée, vitesse basse"
 },
 {
  "id": "C04-B1",
  "family": "Missiles",
  "name": "Essaim",
  "parent": "C04-B",
  "level": 50,
  "desc": "petits missiles nombreux, faible pénétration"
 },
 {
  "id": "C04-B2",
  "family": "Missiles",
  "name": "Alternateur",
  "parent": "C04-B",
  "level": 60,
  "desc": "salves gauche/droite, précision centrale faible"
 },
 {
  "id": "C04-C1",
  "family": "Missiles",
  "name": "Bunkerbuster",
  "parent": "C04-C",
  "level": 50,
  "desc": "roquette résistante, cadence basse"
 },
 {
  "id": "C04-C2",
  "family": "Missiles",
  "name": "Apogée",
  "parent": "C04-C",
  "level": 60,
  "desc": "accélération retardée, faible défense rapprochée"
 },
 {
  "id": "C05-F",
  "family": "Lasers",
  "name": "Photon",
  "parent": "BASE",
  "level": 10,
  "desc": "impulsion lumineuse courte, chauffe"
 },
 {
  "id": "C05-A",
  "family": "Lasers",
  "name": "Rayon",
  "parent": "C05-F",
  "level": 25,
  "desc": "faisceau maintenu, immobilité relative"
 },
 {
  "id": "C05-B",
  "family": "Lasers",
  "name": "Prisme",
  "parent": "C05-F",
  "level": 30,
  "desc": "trois rayons, puissance divisée"
 },
 {
  "id": "C05-C",
  "family": "Lasers",
  "name": "Impulsion",
  "parent": "C05-F",
  "level": 35,
  "desc": "flash puissant, temps mort"
 },
 {
  "id": "C05-A1",
  "family": "Lasers",
  "name": "Hélios",
  "parent": "C05-A",
  "level": 50,
  "desc": "rayon qui chauffe la cible, exige suivi continu"
 },
 {
  "id": "C05-A2",
  "family": "Lasers",
  "name": "Scalpel",
  "parent": "C05-A",
  "level": 60,
  "desc": "rayon étroit précis, tolérance faible"
 },
 {
  "id": "C05-B1",
  "family": "Lasers",
  "name": "Réfracteur",
  "parent": "C05-B",
  "level": 50,
  "desc": "rebond unique sur obstacles prévus, perte de puissance"
 },
 {
  "id": "C05-B2",
  "family": "Lasers",
  "name": "Spectre",
  "parent": "C05-B",
  "level": 60,
  "desc": "rayons divergents, portée réduite"
 },
 {
  "id": "C05-C1",
  "family": "Lasers",
  "name": "Flash",
  "parent": "C05-C",
  "level": 50,
  "desc": "tir instantané annoncé, refroidissement long"
 },
 {
  "id": "C05-C2",
  "family": "Lasers",
  "name": "Pulsar",
  "parent": "C05-C",
  "level": 60,
  "desc": "impulsions périodiques, rythme prévisible"
 },
 {
  "id": "C06-F",
  "family": "Drones",
  "name": "Porte-drones",
  "parent": "BASE",
  "level": 10,
  "desc": "unités dirigées vers visée, nombre limité"
 },
 {
  "id": "C06-A",
  "family": "Drones",
  "name": "Meute",
  "parent": "C06-F",
  "level": 25,
  "desc": "drones rapides fragiles, faible endurance"
 },
 {
  "id": "C06-B",
  "family": "Drones",
  "name": "Gardien",
  "parent": "C06-F",
  "level": 30,
  "desc": "drones lourds lents, faible poursuite"
 },
 {
  "id": "C06-C",
  "family": "Drones",
  "name": "Reconstructeur",
  "parent": "C06-F",
  "level": 35,
  "desc": "remplacement automatique, phase sans défense"
 },
 {
  "id": "C06-A1",
  "family": "Drones",
  "name": "Nuée",
  "parent": "C06-A",
  "level": 50,
  "desc": "nombreux petits drones, dégâts par drone faibles"
 },
 {
  "id": "C06-A2",
  "family": "Drones",
  "name": "Chasseur",
  "parent": "C06-A",
  "level": 60,
  "desc": "drones rapides concentrés, rayon de contrôle court"
 },
 {
  "id": "C06-B1",
  "family": "Drones",
  "name": "Phalange",
  "parent": "C06-B",
  "level": 50,
  "desc": "formation défensive, attaques lentes"
 },
 {
  "id": "C06-B2",
  "family": "Drones",
  "name": "Bélier-drone",
  "parent": "C06-B",
  "level": 60,
  "desc": "drones de contact résistants, retour lent"
 },
 {
  "id": "C06-C1",
  "family": "Drones",
  "name": "Ruche",
  "parent": "C06-C",
  "level": 50,
  "desc": "réserve de drones, coût de régénération en délai"
 },
 {
  "id": "C06-C2",
  "family": "Drones",
  "name": "Recycleur",
  "parent": "C06-C",
  "level": 60,
  "desc": "récupère drones survivants, pertes coûteuses"
 },
 {
  "id": "C07-F",
  "family": "Mines",
  "name": "Poseur",
  "parent": "BASE",
  "level": 10,
  "desc": "mines armées avec délai, nombre limité"
 },
 {
  "id": "C07-A",
  "family": "Mines",
  "name": "Champ",
  "parent": "C07-F",
  "level": 25,
  "desc": "mines nombreuses faibles, faible portée pose"
 },
 {
  "id": "C07-B",
  "family": "Mines",
  "name": "Charge",
  "parent": "C07-F",
  "level": 30,
  "desc": "mines lourdes rares, armement long"
 },
 {
  "id": "C07-C",
  "family": "Mines",
  "name": "Mobile",
  "parent": "C07-F",
  "level": 35,
  "desc": "mines qui dérivent, contrôle imprécis"
 },
 {
  "id": "C07-A1",
  "family": "Mines",
  "name": "Tapis",
  "parent": "C07-A",
  "level": 50,
  "desc": "ligne de mines, signal visible"
 },
 {
  "id": "C07-A2",
  "family": "Mines",
  "name": "Couronne",
  "parent": "C07-A",
  "level": 60,
  "desc": "anneau de mines, faiblesse au centre"
 },
 {
  "id": "C07-B1",
  "family": "Mines",
  "name": "Crater",
  "parent": "C07-B",
  "level": 50,
  "desc": "mine explosive large, désamorçable avant armement"
 },
 {
  "id": "C07-B2",
  "family": "Mines",
  "name": "Shrapnel",
  "parent": "C07-B",
  "level": 60,
  "desc": "fragments au déclenchement, moins de dégâts directs"
 },
 {
  "id": "C07-C1",
  "family": "Mines",
  "name": "Dérive",
  "parent": "C07-C",
  "level": 50,
  "desc": "mines flottantes lentes, durée courte"
 },
 {
  "id": "C07-C2",
  "family": "Mines",
  "name": "Magnétique",
  "parent": "C07-C",
  "level": 60,
  "desc": "attraction mine à très courte portée, faible explosion"
 },
 {
  "id": "C08-F",
  "family": "Pièges",
  "name": "Trappeur",
  "parent": "BASE",
  "level": 10,
  "desc": "projectiles stationnaires, portée limitée"
 },
 {
  "id": "C08-A",
  "family": "Pièges",
  "name": "Barbelé",
  "parent": "C08-F",
  "level": 25,
  "desc": "pièges persistants, dégâts faibles"
 },
 {
  "id": "C08-B",
  "family": "Pièges",
  "name": "Baliste",
  "parent": "C08-F",
  "level": 30,
  "desc": "piège tire une fois, déclenchement visible"
 },
 {
  "id": "C08-C",
  "family": "Pièges",
  "name": "Architecte",
  "parent": "C08-F",
  "level": 35,
  "desc": "barrières destructibles, limite stricte"
 },
 {
  "id": "C08-A1",
  "family": "Pièges",
  "name": "Labyrinthe",
  "parent": "C08-A",
  "level": 50,
  "desc": "petites barrières, durée courte"
 },
 {
  "id": "C08-A2",
  "family": "Pièges",
  "name": "Herse",
  "parent": "C08-A",
  "level": 60,
  "desc": "ligne blessante, contournable"
 },
 {
  "id": "C08-B1",
  "family": "Pièges",
  "name": "Guetteur",
  "parent": "C08-B",
  "level": 50,
  "desc": "piège tir directionnel, angle mort arrière"
 },
 {
  "id": "C08-B2",
  "family": "Pièges",
  "name": "Arbalète",
  "parent": "C08-B",
  "level": 60,
  "desc": "piège puissant annoncé, cadence lente"
 },
 {
  "id": "C08-C1",
  "family": "Pièges",
  "name": "Rempart",
  "parent": "C08-C",
  "level": 50,
  "desc": "obstacles résistants, aucune invulnérabilité"
 },
 {
  "id": "C08-C2",
  "family": "Pièges",
  "name": "Bastille",
  "parent": "C08-C",
  "level": 60,
  "desc": "enceinte ouverte, interdit blocage de spawn"
 },
 {
  "id": "C09-F",
  "family": "Collision",
  "name": "Bélier",
  "parent": "BASE",
  "level": 10,
  "desc": "dégâts corporels élevés, canon faible"
 },
 {
  "id": "C09-A",
  "family": "Collision",
  "name": "Pointe",
  "parent": "C09-F",
  "level": 25,
  "desc": "charge par déplacement continu, virages annulent"
 },
 {
  "id": "C09-B",
  "family": "Collision",
  "name": "Broyeur",
  "parent": "C09-F",
  "level": 30,
  "desc": "contact prolongé, lent"
 },
 {
  "id": "C09-C",
  "family": "Collision",
  "name": "Éperon",
  "parent": "C09-F",
  "level": 35,
  "desc": "fort impact frontal, flanc fragile"
 },
 {
  "id": "C09-A1",
  "family": "Collision",
  "name": "Lancier",
  "parent": "C09-A",
  "level": 50,
  "desc": "nez allongé signalé, rotation lente"
 },
 {
  "id": "C09-A2",
  "family": "Collision",
  "name": "Comète",
  "parent": "C09-A",
  "level": 60,
  "desc": "vitesse après trajet droit, freinage difficile"
 },
 {
  "id": "C09-B1",
  "family": "Collision",
  "name": "Concasseur",
  "parent": "C09-B",
  "level": 50,
  "desc": "résistance au contact, très faible portée"
 },
 {
  "id": "C09-B2",
  "family": "Collision",
  "name": "Roue-dentée",
  "parent": "C09-B",
  "level": 60,
  "desc": "contact périphérique, projectile faible"
 },
 {
  "id": "C09-C1",
  "family": "Collision",
  "name": "Juggernaut",
  "parent": "C09-C",
  "level": 50,
  "desc": "blindage frontal, arrière vulnérable"
 },
 {
  "id": "C09-C2",
  "family": "Collision",
  "name": "Marteau",
  "parent": "C09-C",
  "level": 60,
  "desc": "impact initial fort puis délai, pas de dégâts par frame"
 },
 {
  "id": "C10-F",
  "family": "Dispersion",
  "name": "Fusil",
  "parent": "BASE",
  "level": 10,
  "desc": "gerbe courte, faible portée"
 },
 {
  "id": "C10-A",
  "family": "Dispersion",
  "name": "Éventail-canon",
  "parent": "C10-F",
  "level": 25,
  "desc": "large cône, faibles dégâts par bille"
 },
 {
  "id": "C10-B",
  "family": "Dispersion",
  "name": "Double-gerbe",
  "parent": "C10-F",
  "level": 30,
  "desc": "deux salves, recharge longue"
 },
 {
  "id": "C10-C",
  "family": "Dispersion",
  "name": "Concentrateur",
  "parent": "C10-F",
  "level": 35,
  "desc": "gerbe plus serrée en maintien, mobilité réduite"
 },
 {
  "id": "C10-A1",
  "family": "Dispersion",
  "name": "Ouragan",
  "parent": "C10-A",
  "level": 50,
  "desc": "large couverture, centre peu puissant"
 },
 {
  "id": "C10-A2",
  "family": "Dispersion",
  "name": "Balayeur",
  "parent": "C10-A",
  "level": 60,
  "desc": "cône latéral, portée très courte"
 },
 {
  "id": "C10-B1",
  "family": "Dispersion",
  "name": "Décharge",
  "parent": "C10-B",
  "level": 50,
  "desc": "deux gerbes rapides, temps mort long"
 },
 {
  "id": "C10-B2",
  "family": "Dispersion",
  "name": "Alternance",
  "parent": "C10-B",
  "level": 60,
  "desc": "gerbes gauche/droite, rythme imposé"
 },
 {
  "id": "C10-C1",
  "family": "Dispersion",
  "name": "Entonnoir",
  "parent": "C10-C",
  "level": 50,
  "desc": "cône resserré chargé, vulnérable pendant charge"
 },
 {
  "id": "C10-C2",
  "family": "Dispersion",
  "name": "Grêle",
  "parent": "C10-C",
  "level": 60,
  "desc": "billes lentes nombreuses, pénétration faible"
 },
 {
  "id": "C11-F",
  "family": "Rebond",
  "name": "Ricocheur",
  "parent": "BASE",
  "level": 10,
  "desc": "balle rebondit une fois sur décor, dégâts réduits"
 },
 {
  "id": "C11-A",
  "family": "Rebond",
  "name": "Billard",
  "parent": "C11-F",
  "level": 25,
  "desc": "rebonds calculés, vitesse moindre"
 },
 {
  "id": "C11-B",
  "family": "Rebond",
  "name": "Boîte",
  "parent": "C11-F",
  "level": 30,
  "desc": "projectiles lents persistants, faible dégâts"
 },
 {
  "id": "C11-C",
  "family": "Rebond",
  "name": "Angles",
  "parent": "C11-F",
  "level": 35,
  "desc": "canons obliques, visée indirecte"
 },
 {
  "id": "C11-A1",
  "family": "Rebond",
  "name": "Carambole",
  "parent": "C11-A",
  "level": 50,
  "desc": "deux rebonds max, pertes à chaque rebond"
 },
 {
  "id": "C11-A2",
  "family": "Rebond",
  "name": "Retour",
  "parent": "C11-A",
  "level": 60,
  "desc": "rebond revient vers zone de départ, trajet prévisible"
 },
 {
  "id": "C11-B1",
  "family": "Rebond",
  "name": "Résonance",
  "parent": "C11-B",
  "level": 50,
  "desc": "persistance accrue, nombre de balles limité"
 },
 {
  "id": "C11-B2",
  "family": "Rebond",
  "name": "Chambre",
  "parent": "C11-B",
  "level": 60,
  "desc": "petit champ de projectiles, faible portée"
 },
 {
  "id": "C11-C1",
  "family": "Rebond",
  "name": "Diagonale",
  "parent": "C11-C",
  "level": 50,
  "desc": "deux tirs obliques précis, angle mort face"
 },
 {
  "id": "C11-C2",
  "family": "Rebond",
  "name": "Miroir",
  "parent": "C11-C",
  "level": 60,
  "desc": "salves symétriques, faibles dégâts concentrés"
 },
 {
  "id": "C12-F",
  "family": "Tourelles",
  "name": "Sentinelle-tank",
  "parent": "BASE",
  "level": 10,
  "desc": "petit canon automatique secondaire, tir principal moyen"
 },
 {
  "id": "C12-A",
  "family": "Tourelles",
  "name": "Double-garde",
  "parent": "C12-F",
  "level": 25,
  "desc": "deux secondaires courtes portées, lent"
 },
 {
  "id": "C12-B",
  "family": "Tourelles",
  "name": "Concentré",
  "parent": "C12-F",
  "level": 30,
  "desc": "canon principal lourd, défense secondaire faible"
 },
 {
  "id": "C12-C",
  "family": "Tourelles",
  "name": "Orbitale",
  "parent": "C12-F",
  "level": 35,
  "desc": "secondaires tournantes, tirs périodiques"
 },
 {
  "id": "C12-A1",
  "family": "Tourelles",
  "name": "Tri-garde",
  "parent": "C12-A",
  "level": 50,
  "desc": "trois secondaires, portée très courte"
 },
 {
  "id": "C12-A2",
  "family": "Tourelles",
  "name": "Poste",
  "parent": "C12-A",
  "level": 60,
  "desc": "défense accrue quand lent, vulnérable artillerie"
 },
 {
  "id": "C12-B1",
  "family": "Tourelles",
  "name": "Commandant",
  "parent": "C12-B",
  "level": 50,
  "desc": "gros canon et mini-tourelle, cadence faible"
 },
 {
  "id": "C12-B2",
  "family": "Tourelles",
  "name": "Croiseur",
  "parent": "C12-B",
  "level": 60,
  "desc": "double canon lourd, rotation lente"
 },
 {
  "id": "C12-C1",
  "family": "Tourelles",
  "name": "Satellite",
  "parent": "C12-C",
  "level": 50,
  "desc": "canons orbitaux, alignement intermittent"
 },
 {
  "id": "C12-C2",
  "family": "Tourelles",
  "name": "Planétaire",
  "parent": "C12-C",
  "level": 60,
  "desc": "anneau défensif destructible, long remplacement"
 },
 {
  "id": "C13-F",
  "family": "Énergie",
  "name": "Arc",
  "parent": "BASE",
  "level": 10,
  "desc": "décharge courte, chauffe rapide"
 },
 {
  "id": "C13-A",
  "family": "Énergie",
  "name": "Chaîne",
  "parent": "C13-F",
  "level": 25,
  "desc": "rebond entre cibles proches, dégâts décroissants"
 },
 {
  "id": "C13-B",
  "family": "Énergie",
  "name": "Sphère",
  "parent": "C13-F",
  "level": 30,
  "desc": "orbe énergétique lente, interception possible"
 },
 {
  "id": "C13-C",
  "family": "Énergie",
  "name": "Réacteur",
  "parent": "C13-F",
  "level": 35,
  "desc": "tir selon chaleur, surchauffe forcée"
 },
 {
  "id": "C13-A1",
  "family": "Énergie",
  "name": "Foudre",
  "parent": "C13-A",
  "level": 50,
  "desc": "chaîne courte rapide, faible dégât isolé"
 },
 {
  "id": "C13-A2",
  "family": "Énergie",
  "name": "Conducteur",
  "parent": "C13-A",
  "level": 60,
  "desc": "cibles alignées favorisées, rayon étroit"
 },
 {
  "id": "C13-B1",
  "family": "Énergie",
  "name": "Orbite",
  "parent": "C13-B",
  "level": 50,
  "desc": "orbe courbe, durée limitée"
 },
 {
  "id": "C13-B2",
  "family": "Énergie",
  "name": "Nova",
  "parent": "C13-B",
  "level": 60,
  "desc": "orbe éclate après délai, avertissement clair"
 },
 {
  "id": "C13-C1",
  "family": "Énergie",
  "name": "Fournaise",
  "parent": "C13-C",
  "level": 50,
  "desc": "puissance croît en tir continu, refroidissement long"
 },
 {
  "id": "C13-C2",
  "family": "Énergie",
  "name": "Thermique",
  "parent": "C13-C",
  "level": 60,
  "desc": "alternance chaud/froid, rythme complexe"
 },
 {
  "id": "C14-F",
  "family": "Contrôle",
  "name": "Répulseur",
  "parent": "BASE",
  "level": 10,
  "desc": "tirs repoussent légèrement, dégâts réduits"
 },
 {
  "id": "C14-A",
  "family": "Contrôle",
  "name": "Givre",
  "parent": "C14-F",
  "level": 25,
  "desc": "ralentissement plafonné, faible dégâts"
 },
 {
  "id": "C14-B",
  "family": "Contrôle",
  "name": "Gravité",
  "parent": "C14-F",
  "level": 30,
  "desc": "champ local bref, aucun immobilisme total"
 },
 {
  "id": "C14-C",
  "family": "Contrôle",
  "name": "Onde",
  "parent": "C14-F",
  "level": 35,
  "desc": "projectile large pousse, faible cadence"
 },
 {
  "id": "C14-A1",
  "family": "Contrôle",
  "name": "Banquise",
  "parent": "C14-A",
  "level": 50,
  "desc": "ralentissement zone court, pas de cumul infini"
 },
 {
  "id": "C14-A2",
  "family": "Contrôle",
  "name": "Gel-directionnel",
  "parent": "C14-A",
  "level": 60,
  "desc": "ralentit davantage sur tir frontal, faible portée"
 },
 {
  "id": "C14-B1",
  "family": "Contrôle",
  "name": "Puits",
  "parent": "C14-B",
  "level": 50,
  "desc": "attire légèrement vers impact, esquivable"
 },
 {
  "id": "C14-B2",
  "family": "Contrôle",
  "name": "Marée",
  "parent": "C14-B",
  "level": 60,
  "desc": "alternance traction/rejet annoncée, dégâts modestes"
 },
 {
  "id": "C14-C1",
  "family": "Contrôle",
  "name": "Ressac",
  "parent": "C14-C",
  "level": 50,
  "desc": "onde aller-retour, trajet prévisible"
 },
 {
  "id": "C14-C2",
  "family": "Contrôle",
  "name": "Vague",
  "parent": "C14-C",
  "level": 60,
  "desc": "grand front de poussée, ne traverse pas tout le décor"
 },
 {
  "id": "C15-F",
  "family": "Hybrides",
  "name": "Composite",
  "parent": "BASE",
  "level": 10,
  "desc": "petit canon et petit drone, puissance partagée"
 },
 {
  "id": "C15-A",
  "family": "Hybrides",
  "name": "Artilleur-drone",
  "parent": "C15-F",
  "level": 25,
  "desc": "obus et drones faibles, gestion du tir commune"
 },
 {
  "id": "C15-B",
  "family": "Hybrides",
  "name": "Mineur-canon",
  "parent": "C15-F",
  "level": 30,
  "desc": "canon et pose automatique limitée, cadence moindre"
 },
 {
  "id": "C15-C",
  "family": "Hybrides",
  "name": "Optique-balistique",
  "parent": "C15-F",
  "level": 35,
  "desc": "impulsion laser et balle, chauffe"
 },
 {
  "id": "C15-A1",
  "family": "Hybrides",
  "name": "Escorte",
  "parent": "C15-A",
  "level": 50,
  "desc": "drones protègent obusier, portée drone courte"
 },
 {
  "id": "C15-A2",
  "family": "Hybrides",
  "name": "Messager",
  "parent": "C15-A",
  "level": 60,
  "desc": "drones offensifs et petit mortier, fragile"
 },
 {
  "id": "C15-B1",
  "family": "Hybrides",
  "name": "Frontière",
  "parent": "C15-B",
  "level": 50,
  "desc": "mine derrière à chaque salve, cadence limitée"
 },
 {
  "id": "C15-B2",
  "family": "Hybrides",
  "name": "Piégeur",
  "parent": "C15-B",
  "level": 60,
  "desc": "balles déposent un piège faible, plafond partagé"
 },
 {
  "id": "C15-C1",
  "family": "Hybrides",
  "name": "Alternateur-optique",
  "parent": "C15-C",
  "level": 50,
  "desc": "laser puis balle, cycle obligatoire"
 },
 {
  "id": "C15-C2",
  "family": "Hybrides",
  "name": "Fusion",
  "parent": "C15-C",
  "level": 60,
  "desc": "balle éclate en impulsion courte, aucune cascade"
 }
];

export const RAW_MODS: RawMod[] = [
 {
  "id": "W01-01",
  "kind": "weapon",
  "group": "Balistique",
  "name": "Pointe dure",
  "desc": "traverse une cible de plus mais dégâts réduits"
 },
 {
  "id": "W01-02",
  "kind": "weapon",
  "group": "Balistique",
  "name": "Chemise lourde",
  "desc": "plus de pénétration mais vitesse moindre"
 },
 {
  "id": "W01-03",
  "kind": "weapon",
  "group": "Balistique",
  "name": "Traceur",
  "desc": "balle lisible plus rapide mais dégâts moindres"
 },
 {
  "id": "W01-04",
  "kind": "weapon",
  "group": "Balistique",
  "name": "Creuse",
  "desc": "dégâts directs augmentés mais zéro traversée"
 },
 {
  "id": "W01-05",
  "kind": "weapon",
  "group": "Balistique",
  "name": "Sous-calibrée",
  "desc": "balle étroite rapide mais dégâts moindres"
 },
 {
  "id": "W01-06",
  "kind": "weapon",
  "group": "Balistique",
  "name": "Lente pesante",
  "desc": "fort recul cible mais trajectoire facile à éviter"
 },
 {
  "id": "W01-07",
  "kind": "weapon",
  "group": "Balistique",
  "name": "Freinée",
  "desc": "ralentit en vol et dure plus mais portée moindre"
 },
 {
  "id": "W01-08",
  "kind": "weapon",
  "group": "Balistique",
  "name": "Accélérée",
  "desc": "démarre lentement puis accélère mais faible corps à corps"
 },
 {
  "id": "W01-09",
  "kind": "weapon",
  "group": "Balistique",
  "name": "Fuyante",
  "desc": "portée longue mais dégâts décroissent plus vite"
 },
 {
  "id": "W01-10",
  "kind": "weapon",
  "group": "Balistique",
  "name": "Proximité",
  "desc": "dégâts accrus proche mais portée réduite"
 },
 {
  "id": "W02-01",
  "kind": "weapon",
  "group": "Fragments",
  "name": "Éclats frontaux",
  "desc": "deux fragments en avant mais impact réduit"
 },
 {
  "id": "W02-02",
  "kind": "weapon",
  "group": "Fragments",
  "name": "Éclats latéraux",
  "desc": "fragments sur côtés mais centre faible"
 },
 {
  "id": "W02-03",
  "kind": "weapon",
  "group": "Fragments",
  "name": "Éclat arrière",
  "desc": "fragment derrière impact mais puissance divisée"
 },
 {
  "id": "W02-04",
  "kind": "weapon",
  "group": "Fragments",
  "name": "Grappe tardive",
  "desc": "séparation à distance fixe mais trajectoire annoncée"
 },
 {
  "id": "W02-05",
  "kind": "weapon",
  "group": "Fragments",
  "name": "Gerbe terminale",
  "desc": "fragments à expiration mais pas sur impact"
 },
 {
  "id": "W02-06",
  "kind": "weapon",
  "group": "Fragments",
  "name": "Coque fragile",
  "desc": "fragments si interceptée mais projectile fragile"
 },
 {
  "id": "W02-07",
  "kind": "weapon",
  "group": "Fragments",
  "name": "Billes lourdes",
  "desc": "peu de fragments résistants mais lents"
 },
 {
  "id": "W02-08",
  "kind": "weapon",
  "group": "Fragments",
  "name": "Poussière",
  "desc": "nombreux éclats très faibles mais courte vie"
 },
 {
  "id": "W02-09",
  "kind": "weapon",
  "group": "Fragments",
  "name": "Secteur",
  "desc": "fragments vers visée initiale mais aucune correction"
 },
 {
  "id": "W02-10",
  "kind": "weapon",
  "group": "Fragments",
  "name": "Noyau intact",
  "desc": "petit noyau continue après éclatement mais dégâts totaux plafonnés"
 },
 {
  "id": "W03-01",
  "kind": "weapon",
  "group": "Cadences",
  "name": "Rafale double",
  "desc": "deux tirs puis pause mais DPS constant"
 },
 {
  "id": "W03-02",
  "kind": "weapon",
  "group": "Cadences",
  "name": "Rafale triple",
  "desc": "trois tirs puis pause plus longue"
 },
 {
  "id": "W03-03",
  "kind": "weapon",
  "group": "Cadences",
  "name": "Alternée",
  "desc": "deux tubes alternent mais chaque tube lent"
 },
 {
  "id": "W03-04",
  "kind": "weapon",
  "group": "Cadences",
  "name": "Synchrone",
  "desc": "tubes tirent ensemble mais long rechargement"
 },
 {
  "id": "W03-05",
  "kind": "weapon",
  "group": "Cadences",
  "name": "Rampe",
  "desc": "cadence augmente mais chauffe"
 },
 {
  "id": "W03-06",
  "kind": "weapon",
  "group": "Cadences",
  "name": "Premier coup",
  "desc": "premier tir renforcé après repos mais cadence basse"
 },
 {
  "id": "W03-07",
  "kind": "weapon",
  "group": "Cadences",
  "name": "Dernier coup",
  "desc": "fin de chargeur renforcée mais rechargement long"
 },
 {
  "id": "W03-08",
  "kind": "weapon",
  "group": "Cadences",
  "name": "Recharge mobile",
  "desc": "recharge plus vite en mouvement mais dispersion"
 },
 {
  "id": "W03-09",
  "kind": "weapon",
  "group": "Cadences",
  "name": "Recharge stable",
  "desc": "recharge plus vite immobile mais lent"
 },
 {
  "id": "W03-10",
  "kind": "weapon",
  "group": "Cadences",
  "name": "Cycle irrégulier",
  "desc": "salves à intervalles alternés mais prévisibles au HUD"
 },
 {
  "id": "W04-01",
  "kind": "weapon",
  "group": "Trajectoires",
  "name": "Courbe gauche",
  "desc": "courbure constante mais visée indirecte"
 },
 {
  "id": "W04-02",
  "kind": "weapon",
  "group": "Trajectoires",
  "name": "Courbe droite",
  "desc": "courbure inverse mais visée indirecte"
 },
 {
  "id": "W04-03",
  "kind": "weapon",
  "group": "Trajectoires",
  "name": "Sinusoïde",
  "desc": "oscillation latérale mais précision lointaine faible"
 },
 {
  "id": "W04-04",
  "kind": "weapon",
  "group": "Trajectoires",
  "name": "Spirale",
  "desc": "rayon croissant mais faible portée axiale"
 },
 {
  "id": "W04-05",
  "kind": "weapon",
  "group": "Trajectoires",
  "name": "Retour-boomerang",
  "desc": "retour unique mais dégâts retour réduits"
 },
 {
  "id": "W04-06",
  "kind": "weapon",
  "group": "Trajectoires",
  "name": "Ricochet simple",
  "desc": "un rebond décor mais énergie perdue"
 },
 {
  "id": "W04-07",
  "kind": "weapon",
  "group": "Trajectoires",
  "name": "Rebond tank",
  "desc": "ricochet sur une cible mais impact moindre"
 },
 {
  "id": "W04-08",
  "kind": "weapon",
  "group": "Trajectoires",
  "name": "Dérive",
  "desc": "hérite davantage vitesse tank mais tir délicat"
 },
 {
  "id": "W04-09",
  "kind": "weapon",
  "group": "Trajectoires",
  "name": "Stabilisée",
  "desc": "ignore vitesse tank mais recul accru"
 },
 {
  "id": "W04-10",
  "kind": "weapon",
  "group": "Trajectoires",
  "name": "Retardée",
  "desc": "projectile reste bref au départ puis part mais télégraphe visible"
 },
 {
  "id": "W05-01",
  "kind": "weapon",
  "group": "Explosifs",
  "name": "Explosion centrale",
  "desc": "impact renforcé au centre mais rayon réduit"
 },
 {
  "id": "W05-02",
  "kind": "weapon",
  "group": "Explosifs",
  "name": "Souffle large",
  "desc": "rayon accru mais dégâts faibles"
 },
 {
  "id": "W05-03",
  "kind": "weapon",
  "group": "Explosifs",
  "name": "Anneau",
  "desc": "dégâts sur couronne mais centre faible"
 },
 {
  "id": "W05-04",
  "kind": "weapon",
  "group": "Explosifs",
  "name": "Cône explosif",
  "desc": "souffle dirigé mais peu latéral"
 },
 {
  "id": "W05-05",
  "kind": "weapon",
  "group": "Explosifs",
  "name": "Retard",
  "desc": "explose après délai mais avertissement"
 },
 {
  "id": "W05-06",
  "kind": "weapon",
  "group": "Explosifs",
  "name": "Airburst",
  "desc": "explose à distance fixe mais pas de poursuite"
 },
 {
  "id": "W05-07",
  "kind": "weapon",
  "group": "Explosifs",
  "name": "Impact collant",
  "desc": "colle brièvement avant explosion mais dégâts réduits"
 },
 {
  "id": "W05-08",
  "kind": "weapon",
  "group": "Explosifs",
  "name": "Onde répulsive",
  "desc": "pousse mais dégâts faibles"
 },
 {
  "id": "W05-09",
  "kind": "weapon",
  "group": "Explosifs",
  "name": "Charge dispersante",
  "desc": "détruit petits projectiles mais explosion faible"
 },
 {
  "id": "W05-10",
  "kind": "weapon",
  "group": "Explosifs",
  "name": "Double-temps",
  "desc": "deux petites explosions mais même réserve de dégâts"
 },
 {
  "id": "W06-01",
  "kind": "weapon",
  "group": "Missiles",
  "name": "Ailettes",
  "desc": "virages plus serrés mais vitesse basse"
 },
 {
  "id": "W06-02",
  "kind": "weapon",
  "group": "Missiles",
  "name": "Propulseur",
  "desc": "plus rapide mais virages larges"
 },
 {
  "id": "W06-03",
  "kind": "weapon",
  "group": "Missiles",
  "name": "Guidage bref",
  "desc": "corrige au départ puis balistique mais moins de suivi"
 },
 {
  "id": "W06-04",
  "kind": "weapon",
  "group": "Missiles",
  "name": "Guidage tardif",
  "desc": "corrige seulement en fin de vol mais départ vulnérable"
 },
 {
  "id": "W06-05",
  "kind": "weapon",
  "group": "Missiles",
  "name": "Verrou visible",
  "desc": "poursuit cible visée limitée mais avertit"
 },
 {
  "id": "W06-06",
  "kind": "weapon",
  "group": "Missiles",
  "name": "Salve espacée",
  "desc": "roquettes séparées mais rafale lente"
 },
 {
  "id": "W06-07",
  "kind": "weapon",
  "group": "Missiles",
  "name": "Têtes légères",
  "desc": "plusieurs missiles mais dégâts unitaires réduits"
 },
 {
  "id": "W06-08",
  "kind": "weapon",
  "group": "Missiles",
  "name": "Blindage missile",
  "desc": "plus résistant mais lent"
 },
 {
  "id": "W06-09",
  "kind": "weapon",
  "group": "Missiles",
  "name": "Moteur court",
  "desc": "forte accélération courte mais faible portée"
 },
 {
  "id": "W06-10",
  "kind": "weapon",
  "group": "Missiles",
  "name": "Frein terminal",
  "desc": "ralentit proche visée mais interception facile"
 },
 {
  "id": "W07-01",
  "kind": "weapon",
  "group": "Optique",
  "name": "Focalisation",
  "desc": "rayon étroit plus fort mais suivi difficile"
 },
 {
  "id": "W07-02",
  "kind": "weapon",
  "group": "Optique",
  "name": "Diffusion",
  "desc": "rayon large faible mais tolérance accrue"
 },
 {
  "id": "W07-03",
  "kind": "weapon",
  "group": "Optique",
  "name": "Impulsions",
  "desc": "faisceau découpé mais fenêtres sans dégâts"
 },
 {
  "id": "W07-04",
  "kind": "weapon",
  "group": "Optique",
  "name": "Accumulation",
  "desc": "puissance croît sur même cible mais reset changement"
 },
 {
  "id": "W07-05",
  "kind": "weapon",
  "group": "Optique",
  "name": "Balayage",
  "desc": "rayon suit lentement angle mais couverture"
 },
 {
  "id": "W07-06",
  "kind": "weapon",
  "group": "Optique",
  "name": "Prisme court",
  "desc": "division proche en deux mais puissance partagée"
 },
 {
  "id": "W07-07",
  "kind": "weapon",
  "group": "Optique",
  "name": "Optique froide",
  "desc": "moins chauffe mais dégâts faibles"
 },
 {
  "id": "W07-08",
  "kind": "weapon",
  "group": "Optique",
  "name": "Optique chaude",
  "desc": "plus dégâts mais pause refroidissement"
 },
 {
  "id": "W07-09",
  "kind": "weapon",
  "group": "Optique",
  "name": "Réfraction",
  "desc": "un rebond décor mais portée réduite"
 },
 {
  "id": "W07-10",
  "kind": "weapon",
  "group": "Optique",
  "name": "Écho lumineux",
  "desc": "seconde impulsion faible retardée mais tir initial réduit"
 },
 {
  "id": "W08-01",
  "kind": "weapon",
  "group": "Drones",
  "name": "Coques drone",
  "desc": "PV drones augmentés mais lents"
 },
 {
  "id": "W08-02",
  "kind": "weapon",
  "group": "Drones",
  "name": "Ailes drone",
  "desc": "rapides mais fragiles"
 },
 {
  "id": "W08-03",
  "kind": "weapon",
  "group": "Drones",
  "name": "Formation flèche",
  "desc": "concentration frontale mais flancs ouverts"
 },
 {
  "id": "W08-04",
  "kind": "weapon",
  "group": "Drones",
  "name": "Formation anneau",
  "desc": "protège proche mais faible poursuite"
 },
 {
  "id": "W08-05",
  "kind": "weapon",
  "group": "Drones",
  "name": "Rappel passif",
  "desc": "revient si faible vie mais temps offensif réduit"
 },
 {
  "id": "W08-06",
  "kind": "weapon",
  "group": "Drones",
  "name": "Réserve",
  "desc": "remplacement plus rapide mais maximum actif moindre"
 },
 {
  "id": "W08-07",
  "kind": "weapon",
  "group": "Drones",
  "name": "Long contrôle",
  "desc": "rayon contrôle accru mais drones plus faibles"
 },
 {
  "id": "W08-08",
  "kind": "weapon",
  "group": "Drones",
  "name": "Garde rapprochée",
  "desc": "interception courte mais portée offensive réduite"
 },
 {
  "id": "W08-09",
  "kind": "weapon",
  "group": "Drones",
  "name": "Assaut alterné",
  "desc": "moitié attaque moitié revient mais burst faible"
 },
 {
  "id": "W08-10",
  "kind": "weapon",
  "group": "Drones",
  "name": "Dernier voyage",
  "desc": "drone mourant continue brièvement sans régénération mais durée limitée"
 },
 {
  "id": "W09-01",
  "kind": "weapon",
  "group": "Mines et pièges",
  "name": "Armement rapide",
  "desc": "délai court mais explosion réduite"
 },
 {
  "id": "W09-02",
  "kind": "weapon",
  "group": "Mines et pièges",
  "name": "Armement lent",
  "desc": "puissant mais facile à détruire avant"
 },
 {
  "id": "W09-03",
  "kind": "weapon",
  "group": "Mines et pièges",
  "name": "Persistance",
  "desc": "durée longue mais nombre max moindre"
 },
 {
  "id": "W09-04",
  "kind": "weapon",
  "group": "Mines et pièges",
  "name": "Stock dense",
  "desc": "plus objets mais faibles"
 },
 {
  "id": "W09-05",
  "kind": "weapon",
  "group": "Mines et pièges",
  "name": "Ligne de pose",
  "desc": "placement aligné mais faible couverture latérale"
 },
 {
  "id": "W09-06",
  "kind": "weapon",
  "group": "Mines et pièges",
  "name": "Dispersion pose",
  "desc": "placement écarté mais imprécis"
 },
 {
  "id": "W09-07",
  "kind": "weapon",
  "group": "Mines et pièges",
  "name": "Dérive piège",
  "desc": "déplacement faible mais contrôle moindre"
 },
 {
  "id": "W09-08",
  "kind": "weapon",
  "group": "Mines et pièges",
  "name": "Signal lumineux",
  "desc": "grande zone de déclenchement mais mine très visible"
 },
 {
  "id": "W09-09",
  "kind": "weapon",
  "group": "Mines et pièges",
  "name": "Détonation unique",
  "desc": "souffle puissant mais chaîne interdite"
 },
 {
  "id": "W09-10",
  "kind": "weapon",
  "group": "Mines et pièges",
  "name": "Recyclage pose",
  "desc": "ancien objet disparaît au nouveau mais restitution de délai partielle"
 },
 {
  "id": "W10-01",
  "kind": "weapon",
  "group": "Collision offensive",
  "name": "Pare-choc lourd",
  "desc": "impact plus fort mais vitesse moindre"
 },
 {
  "id": "W10-02",
  "kind": "weapon",
  "group": "Collision offensive",
  "name": "Pointe frontale",
  "desc": "dégâts face élevés mais flancs faibles"
 },
 {
  "id": "W10-03",
  "kind": "weapon",
  "group": "Collision offensive",
  "name": "Flancs dentés",
  "desc": "dégâts latéraux mais front moindre"
 },
 {
  "id": "W10-04",
  "kind": "weapon",
  "group": "Collision offensive",
  "name": "Inertie offensive",
  "desc": "impact selon trajet droit mais virages réduisent"
 },
 {
  "id": "W10-05",
  "kind": "weapon",
  "group": "Collision offensive",
  "name": "Contact prolongé",
  "desc": "dégâts soutenus mais impact initial faible"
 },
 {
  "id": "W10-06",
  "kind": "weapon",
  "group": "Collision offensive",
  "name": "Impact sec",
  "desc": "burst contact puis délai long"
 },
 {
  "id": "W10-07",
  "kind": "weapon",
  "group": "Collision offensive",
  "name": "Rejet",
  "desc": "pousse au contact mais dégâts moindres"
 },
 {
  "id": "W10-08",
  "kind": "weapon",
  "group": "Collision offensive",
  "name": "Accroche",
  "desc": "ralentit brièvement au contact mais soi aussi"
 },
 {
  "id": "W10-09",
  "kind": "weapon",
  "group": "Collision offensive",
  "name": "Recul contrôlé",
  "desc": "réduit recul subi mais accélération faible"
 },
 {
  "id": "W10-10",
  "kind": "weapon",
  "group": "Collision offensive",
  "name": "Éperon fragile",
  "desc": "impact fort mais blindage de vie réduit"
 },
 {
  "id": "W11-01",
  "kind": "weapon",
  "group": "Interception",
  "name": "Balle robuste",
  "desc": "survit petits projectiles mais cadence faible"
 },
 {
  "id": "W11-02",
  "kind": "weapon",
  "group": "Interception",
  "name": "Contre-feu",
  "desc": "bonus aux projectiles ennemis mais moins aux tanks"
 },
 {
  "id": "W11-03",
  "kind": "weapon",
  "group": "Interception",
  "name": "Écran de billes",
  "desc": "salve défensive courte mais portée faible"
 },
 {
  "id": "W11-04",
  "kind": "weapon",
  "group": "Interception",
  "name": "Trajectoire dense",
  "desc": "balle grosse intercepte mais facile à toucher"
 },
 {
  "id": "W11-05",
  "kind": "weapon",
  "group": "Interception",
  "name": "Pare-éclats",
  "desc": "réduit fragments reçus si tir vers eux mais faible DPS"
 },
 {
  "id": "W11-06",
  "kind": "weapon",
  "group": "Interception",
  "name": "Tir de couverture",
  "desc": "projectiles durent proche mais vitesse faible"
 },
 {
  "id": "W11-07",
  "kind": "weapon",
  "group": "Interception",
  "name": "Barrière tirée",
  "desc": "projectile large lent destructible mais cadence basse"
 },
 {
  "id": "W11-08",
  "kind": "weapon",
  "group": "Interception",
  "name": "Érosion",
  "desc": "plus dégâts contre drones mais moins contre tank"
 },
 {
  "id": "W11-09",
  "kind": "weapon",
  "group": "Interception",
  "name": "Déminage",
  "desc": "plus dégâts pièges mais moins formes"
 },
 {
  "id": "W11-10",
  "kind": "weapon",
  "group": "Interception",
  "name": "Canon anti-orbe",
  "desc": "intercepte énergie destructible mais pas les rayons instantanés"
 },
 {
  "id": "W12-01",
  "kind": "weapon",
  "group": "Ciblage et portée",
  "name": "Concentration",
  "desc": "dispersion diminue en maintien mais vitesse réduite"
 },
 {
  "id": "W12-02",
  "kind": "weapon",
  "group": "Ciblage et portée",
  "name": "Tir mobile",
  "desc": "dispersion moindre en mouvement mais dégâts réduits"
 },
 {
  "id": "W12-03",
  "kind": "weapon",
  "group": "Ciblage et portée",
  "name": "Visée stable",
  "desc": "portée accrue si immobile mais délai installation"
 },
 {
  "id": "W12-04",
  "kind": "weapon",
  "group": "Ciblage et portée",
  "name": "Anti-groupe",
  "desc": "bonus explosion sur groupes plafonné mais isolé faible"
 },
 {
  "id": "W12-05",
  "kind": "weapon",
  "group": "Ciblage et portée",
  "name": "Duel",
  "desc": "dégâts soutenus même cible mais changement pénalisé"
 },
 {
  "id": "W12-06",
  "kind": "weapon",
  "group": "Ciblage et portée",
  "name": "Chasse-monstre",
  "desc": "bonus monstres mais dégâts tanks réduits"
 },
 {
  "id": "W12-07",
  "kind": "weapon",
  "group": "Ciblage et portée",
  "name": "Chasse-formes",
  "desc": "bonus formes mais faible PvP"
 },
 {
  "id": "W12-08",
  "kind": "weapon",
  "group": "Ciblage et portée",
  "name": "Anti-blindage",
  "desc": "réduit part résistance mais dégâts bruts moindres"
 },
 {
  "id": "W12-09",
  "kind": "weapon",
  "group": "Ciblage et portée",
  "name": "Zone courte",
  "desc": "durée projectile réduite mais vitesse accrue"
 },
 {
  "id": "W12-10",
  "kind": "weapon",
  "group": "Ciblage et portée",
  "name": "Portée modulée",
  "desc": "charge règle distance mais cadence faible"
 },
 {
  "id": "H01-01",
  "kind": "chassis",
  "group": "Mobilité",
  "name": "Chenilles légères",
  "desc": "accélération accrue mais vie moindre"
 },
 {
  "id": "H01-02",
  "kind": "chassis",
  "group": "Mobilité",
  "name": "Chenilles lourdes",
  "desc": "vie accrue mais accélération faible"
 },
 {
  "id": "H01-03",
  "kind": "chassis",
  "group": "Mobilité",
  "name": "Roues rapides",
  "desc": "vitesse ligne droite mais freinage long"
 },
 {
  "id": "H01-04",
  "kind": "chassis",
  "group": "Mobilité",
  "name": "Pivot court",
  "desc": "rotation visuelle et réponse améliorées mais recul accru"
 },
 {
  "id": "H01-05",
  "kind": "chassis",
  "group": "Mobilité",
  "name": "Frein renforcé",
  "desc": "arrêt rapide mais vitesse max faible"
 },
 {
  "id": "H01-06",
  "kind": "chassis",
  "group": "Mobilité",
  "name": "Inertie longue",
  "desc": "conserve vitesse mais contrôle difficile"
 },
 {
  "id": "H01-07",
  "kind": "chassis",
  "group": "Mobilité",
  "name": "Marche arrière",
  "desc": "retrait facilité mais vitesse avant moindre"
 },
 {
  "id": "H01-08",
  "kind": "chassis",
  "group": "Mobilité",
  "name": "Adhérence",
  "desc": "résiste poussée mais lente accélération"
 },
 {
  "id": "H01-09",
  "kind": "chassis",
  "group": "Mobilité",
  "name": "Glisse",
  "desc": "déplacement souple mais faible freinage"
 },
 {
  "id": "H01-10",
  "kind": "chassis",
  "group": "Mobilité",
  "name": "Cruisière",
  "desc": "vitesse après repos offensif mais perdue au tir"
 },
 {
  "id": "H02-01",
  "kind": "chassis",
  "group": "Blindage",
  "name": "Plaque frontale",
  "desc": "réduction face mais arrière fragile"
 },
 {
  "id": "H02-02",
  "kind": "chassis",
  "group": "Blindage",
  "name": "Plaques latérales",
  "desc": "flancs résistants mais face fragile"
 },
 {
  "id": "H02-03",
  "kind": "chassis",
  "group": "Blindage",
  "name": "Plaque arrière",
  "desc": "protège fuite mais attaque frontale risquée"
 },
 {
  "id": "H02-04",
  "kind": "chassis",
  "group": "Blindage",
  "name": "Coque uniforme",
  "desc": "petite résistance partout mais mobilité réduite"
 },
 {
  "id": "H02-05",
  "kind": "chassis",
  "group": "Blindage",
  "name": "Coque anti-balles",
  "desc": "résiste balistique mais faible énergie"
 },
 {
  "id": "H02-06",
  "kind": "chassis",
  "group": "Blindage",
  "name": "Coque isolante",
  "desc": "résiste énergie mais faible balistique"
 },
 {
  "id": "H02-07",
  "kind": "chassis",
  "group": "Blindage",
  "name": "Coque anti-souffle",
  "desc": "résiste explosions mais faible direct"
 },
 {
  "id": "H02-08",
  "kind": "chassis",
  "group": "Blindage",
  "name": "Pare-contact",
  "desc": "résiste collision mais faible tir"
 },
 {
  "id": "H02-09",
  "kind": "chassis",
  "group": "Blindage",
  "name": "Blindage lourd",
  "desc": "vie accrue mais hitbox inchangée et lent"
 },
 {
  "id": "H02-10",
  "kind": "chassis",
  "group": "Blindage",
  "name": "Blindage ajouré",
  "desc": "mobilité accrue mais faibles dégâts soutenus subis amplifiés"
 },
 {
  "id": "H03-01",
  "kind": "chassis",
  "group": "Régénération",
  "name": "Réparation lente",
  "desc": "régénère davantage hors combat mais délai plus long"
 },
 {
  "id": "H03-02",
  "kind": "chassis",
  "group": "Régénération",
  "name": "Réparation précoce",
  "desc": "démarre tôt mais débit faible"
 },
 {
  "id": "H03-03",
  "kind": "chassis",
  "group": "Régénération",
  "name": "Réserve de vie",
  "desc": "vie max accrue mais soin lent"
 },
 {
  "id": "H03-04",
  "kind": "chassis",
  "group": "Régénération",
  "name": "Réparation mobile",
  "desc": "soigne en déplacement hors combat mais lent immobile"
 },
 {
  "id": "H03-05",
  "kind": "chassis",
  "group": "Régénération",
  "name": "Réparation stationnaire",
  "desc": "soigne davantage arrêté mais vulnérable"
 },
 {
  "id": "H03-06",
  "kind": "chassis",
  "group": "Régénération",
  "name": "Réparation graduelle",
  "desc": "débit croît sans dommage mais reset au coup"
 },
 {
  "id": "H03-07",
  "kind": "chassis",
  "group": "Régénération",
  "name": "Plaques réparables",
  "desc": "petite protection après long repos mais faible vie"
 },
 {
  "id": "H03-08",
  "kind": "chassis",
  "group": "Régénération",
  "name": "Entretien drones",
  "desc": "soigne drones hors combat mais tank moins"
 },
 {
  "id": "H03-09",
  "kind": "chassis",
  "group": "Régénération",
  "name": "Châssis austère",
  "desc": "régénération fiable mais vie moindre"
 },
 {
  "id": "H03-10",
  "kind": "chassis",
  "group": "Régénération",
  "name": "Survie critique",
  "desc": "soin hors combat sous 20% mais aucun soin au contact"
 },
 {
  "id": "H04-01",
  "kind": "chassis",
  "group": "Recul",
  "name": "Absorbeur",
  "desc": "réduit recul de tir mais vitesse faible"
 },
 {
  "id": "H04-02",
  "kind": "chassis",
  "group": "Recul",
  "name": "Propulsion recul",
  "desc": "recul devient déplacement utile mais visée difficile"
 },
 {
  "id": "H04-03",
  "kind": "chassis",
  "group": "Recul",
  "name": "Stabilisateur lourd",
  "desc": "dispersion recul réduite mais accélération faible"
 },
 {
  "id": "H04-04",
  "kind": "chassis",
  "group": "Recul",
  "name": "Ancrage passif",
  "desc": "plus stable arrêté mais départ lent"
 },
 {
  "id": "H04-05",
  "kind": "chassis",
  "group": "Recul",
  "name": "Suspension",
  "desc": "poussées réduites mais poids accru"
 },
 {
  "id": "H04-06",
  "kind": "chassis",
  "group": "Recul",
  "name": "Contre-masse",
  "desc": "réduit retour gros canon mais cadence moindre"
 },
 {
  "id": "H04-07",
  "kind": "chassis",
  "group": "Recul",
  "name": "Rebond souple",
  "desc": "sort plus vite collisions mais contrôle moindre"
 },
 {
  "id": "H04-08",
  "kind": "chassis",
  "group": "Recul",
  "name": "Fuite arrière",
  "desc": "tir facilite recul arrière mais avance plus lente"
 },
 {
  "id": "H04-09",
  "kind": "chassis",
  "group": "Recul",
  "name": "Viseur amorti",
  "desc": "rotation souple mais suivi rapide limité"
 },
 {
  "id": "H04-10",
  "kind": "chassis",
  "group": "Recul",
  "name": "Retour progressif",
  "desc": "recul étalé mais inertie longue"
 },
 {
  "id": "H05-01",
  "kind": "chassis",
  "group": "Thermique",
  "name": "Radiateur",
  "desc": "refroidit vite mais vie réduite"
 },
 {
  "id": "H05-02",
  "kind": "chassis",
  "group": "Thermique",
  "name": "Réservoir chaleur",
  "desc": "chauffe plus tard mais refroidit lentement"
 },
 {
  "id": "H05-03",
  "kind": "chassis",
  "group": "Thermique",
  "name": "Cycle froid",
  "desc": "tir faible continu mais longue endurance"
 },
 {
  "id": "H05-04",
  "kind": "chassis",
  "group": "Thermique",
  "name": "Cycle chaud",
  "desc": "burst fort mais pause longue"
 },
 {
  "id": "H05-05",
  "kind": "chassis",
  "group": "Thermique",
  "name": "Ventilation mobile",
  "desc": "refroidit en mouvement mais moins arrêté"
 },
 {
  "id": "H05-06",
  "kind": "chassis",
  "group": "Thermique",
  "name": "Ventilation fixe",
  "desc": "refroidit arrêté mais mobilité faible"
 },
 {
  "id": "H05-07",
  "kind": "chassis",
  "group": "Thermique",
  "name": "Sécurité thermique",
  "desc": "coupe avant surchauffe mais cadence plafonnée"
 },
 {
  "id": "H05-08",
  "kind": "chassis",
  "group": "Thermique",
  "name": "Dissipation latérale",
  "desc": "refroidit par pauses brèves mais tir irrégulier"
 },
 {
  "id": "H05-09",
  "kind": "chassis",
  "group": "Thermique",
  "name": "Inertie thermique",
  "desc": "chaleur monte lentement et descend lentement"
 },
 {
  "id": "H05-10",
  "kind": "chassis",
  "group": "Thermique",
  "name": "Compartiment isolé",
  "desc": "surchauffe ne pénalise pas mouvement mais tir plus faible"
 },
 {
  "id": "H06-01",
  "kind": "chassis",
  "group": "Boucliers passifs",
  "name": "Coque-recharge",
  "desc": "petit bouclier hors combat mais vie max faible"
 },
 {
  "id": "H06-02",
  "kind": "chassis",
  "group": "Boucliers passifs",
  "name": "Bouclier frontal",
  "desc": "protection face rechargeable mais flancs ouverts"
 },
 {
  "id": "H06-03",
  "kind": "chassis",
  "group": "Boucliers passifs",
  "name": "Bouclier arrière",
  "desc": "protège retraite mais faible attaque"
 },
 {
  "id": "H06-04",
  "kind": "chassis",
  "group": "Boucliers passifs",
  "name": "Bouclier anti-contact",
  "desc": "absorbe un contact puis longue recharge"
 },
 {
  "id": "H06-05",
  "kind": "chassis",
  "group": "Boucliers passifs",
  "name": "Bouclier anti-éclat",
  "desc": "absorbe petits fragments mais pas gros tirs"
 },
 {
  "id": "H06-06",
  "kind": "chassis",
  "group": "Boucliers passifs",
  "name": "Bouclier diffus",
  "desc": "petite absorption continue plafonnée mais vie moindre"
 },
 {
  "id": "H06-07",
  "kind": "chassis",
  "group": "Boucliers passifs",
  "name": "Bouclier condensé",
  "desc": "absorbe un gros coup plafonné mais long délai"
 },
 {
  "id": "H06-08",
  "kind": "chassis",
  "group": "Boucliers passifs",
  "name": "Bouclier sans soin",
  "desc": "protection se recharge mais régénération vie réduite"
 },
 {
  "id": "H06-09",
  "kind": "chassis",
  "group": "Boucliers passifs",
  "name": "Écran drone",
  "desc": "drones proches protègent mais partagent leur vie"
 },
 {
  "id": "H06-10",
  "kind": "chassis",
  "group": "Boucliers passifs",
  "name": "Bouclier visible",
  "desc": "réserve supérieure mais silhouette signalée"
 },
 {
  "id": "H07-01",
  "kind": "chassis",
  "group": "Détection",
  "name": "Radar proche",
  "desc": "signale menaces proches visibles par règles mais portée courte"
 },
 {
  "id": "H07-02",
  "kind": "chassis",
  "group": "Détection",
  "name": "Compas boss",
  "desc": "direction boss précise mais aucune stat combat"
 },
 {
  "id": "H07-03",
  "kind": "chassis",
  "group": "Détection",
  "name": "Trace de tir",
  "desc": "tirs ennemis restent lisibles plus longtemps mais interface chargée"
 },
 {
  "id": "H07-04",
  "kind": "chassis",
  "group": "Détection",
  "name": "Sonar formes",
  "desc": "indique forme rare proche sans révéler joueurs mais portée faible"
 },
 {
  "id": "H07-05",
  "kind": "chassis",
  "group": "Détection",
  "name": "Alerte arrière",
  "desc": "signale projectile visible arrière mais aucun auto-esquive"
 },
 {
  "id": "H07-06",
  "kind": "chassis",
  "group": "Détection",
  "name": "Lecture pièges",
  "desc": "mine détectable un peu plus loin mais faible vie"
 },
 {
  "id": "H07-07",
  "kind": "chassis",
  "group": "Détection",
  "name": "Suivi agresseur",
  "desc": "dernier agresseur récemment visible indiqué brièvement mais pas au travers carte"
 },
 {
  "id": "H07-08",
  "kind": "chassis",
  "group": "Détection",
  "name": "Capteur monstre",
  "desc": "aggro monstres affichée mais dégâts tank moindres"
 },
 {
  "id": "H07-09",
  "kind": "chassis",
  "group": "Détection",
  "name": "Télémétrie",
  "desc": "distance cible affichée mais ne révèle rien hors champ"
 },
 {
  "id": "H07-10",
  "kind": "chassis",
  "group": "Détection",
  "name": "Balise alliée",
  "desc": "meilleure info alliés en équipes mais pas ennemis cachés"
 },
 {
  "id": "H08-01",
  "kind": "chassis",
  "group": "Résistances contrôle",
  "name": "Anti-givre",
  "desc": "ralentissement réduit mais vitesse max faible"
 },
 {
  "id": "H08-02",
  "kind": "chassis",
  "group": "Résistances contrôle",
  "name": "Anti-traction",
  "desc": "attraction réduite mais poussée subie accrue"
 },
 {
  "id": "H08-03",
  "kind": "chassis",
  "group": "Résistances contrôle",
  "name": "Anti-poussée",
  "desc": "répulsion réduite mais attraction accrue"
 },
 {
  "id": "H08-04",
  "kind": "chassis",
  "group": "Résistances contrôle",
  "name": "Déblocage",
  "desc": "durée contrôle réduite mais vie moindre"
 },
 {
  "id": "H08-05",
  "kind": "chassis",
  "group": "Résistances contrôle",
  "name": "Masse constante",
  "desc": "stabilité contrôle mais accélération faible"
 },
 {
  "id": "H08-06",
  "kind": "chassis",
  "group": "Résistances contrôle",
  "name": "Glissement bref",
  "desc": "sort contrôle plus vite en mouvement mais arrêt fragile"
 },
 {
  "id": "H08-07",
  "kind": "chassis",
  "group": "Résistances contrôle",
  "name": "Isolation thermique",
  "desc": "résiste ralentissement chaud/froid mais balistique accrue"
 },
 {
  "id": "H08-08",
  "kind": "chassis",
  "group": "Résistances contrôle",
  "name": "Roulement",
  "desc": "moins impact collisions mais tirs reçus inchangés"
 },
 {
  "id": "H08-09",
  "kind": "chassis",
  "group": "Résistances contrôle",
  "name": "Souplesse",
  "desc": "résiste contrôles successifs mais premier plein effet"
 },
 {
  "id": "H08-10",
  "kind": "chassis",
  "group": "Résistances contrôle",
  "name": "Ancrage directionnel",
  "desc": "résiste contrôle face mais flancs exposés"
 },
 {
  "id": "H09-01",
  "kind": "chassis",
  "group": "Gestion unités",
  "name": "Baies drones",
  "desc": "plus réserve mais nombre actif inchangé"
 },
 {
  "id": "H09-02",
  "kind": "chassis",
  "group": "Gestion unités",
  "name": "Atelier drone",
  "desc": "reconstruction rapide mais dégâts drones moindres"
 },
 {
  "id": "H09-03",
  "kind": "chassis",
  "group": "Gestion unités",
  "name": "Guide court",
  "desc": "drones très réactifs mais rayon court"
 },
 {
  "id": "H09-04",
  "kind": "chassis",
  "group": "Gestion unités",
  "name": "Guide long",
  "desc": "rayon long mais réaction lente"
 },
 {
  "id": "H09-05",
  "kind": "chassis",
  "group": "Gestion unités",
  "name": "Soutes mines",
  "desc": "plus mines max mais tank lent"
 },
 {
  "id": "H09-06",
  "kind": "chassis",
  "group": "Gestion unités",
  "name": "Compartiment pièges",
  "desc": "durée pièges accrue mais max réduit"
 },
 {
  "id": "H09-07",
  "kind": "chassis",
  "group": "Gestion unités",
  "name": "Gestion tourelles",
  "desc": "secondaires visent vite mais portée faible"
 },
 {
  "id": "H09-08",
  "kind": "chassis",
  "group": "Gestion unités",
  "name": "Énergie partagée",
  "desc": "unités régénèrent sur repos tank mais vie tank faible"
 },
 {
  "id": "H09-09",
  "kind": "chassis",
  "group": "Gestion unités",
  "name": "Coque escorte",
  "desc": "tank résiste si drones proches mais drones n attaquent pas alors"
 },
 {
  "id": "H09-10",
  "kind": "chassis",
  "group": "Gestion unités",
  "name": "Ramassage",
  "desc": "unités reviennent au repos mais temps de sortie accru"
 },
 {
  "id": "H10-01",
  "kind": "chassis",
  "group": "Économie de tir",
  "name": "Chargeur large",
  "desc": "plus tirs avant pause mais recharge longue"
 },
 {
  "id": "H10-02",
  "kind": "chassis",
  "group": "Économie de tir",
  "name": "Chargeur court",
  "desc": "petites salves mais recharge courte"
 },
 {
  "id": "H10-03",
  "kind": "chassis",
  "group": "Économie de tir",
  "name": "Réserve stable",
  "desc": "cadence constante mais burst réduit"
 },
 {
  "id": "H10-04",
  "kind": "chassis",
  "group": "Économie de tir",
  "name": "Économie énergie",
  "desc": "chaleur faible mais dégâts réduits"
 },
 {
  "id": "H10-05",
  "kind": "chassis",
  "group": "Économie de tir",
  "name": "Alimentation lourde",
  "desc": "gros tir mais accélération faible"
 },
 {
  "id": "H10-06",
  "kind": "chassis",
  "group": "Économie de tir",
  "name": "Double circuit",
  "desc": "alterne canons pour réduire chauffe mais salves non synchrones"
 },
 {
  "id": "H10-07",
  "kind": "chassis",
  "group": "Économie de tir",
  "name": "Amorce",
  "desc": "premier tir rapide après repos mais suite lente"
 },
 {
  "id": "H10-08",
  "kind": "chassis",
  "group": "Économie de tir",
  "name": "Régulateur",
  "desc": "limite pointe de cadence mais refroidissement fiable"
 },
 {
  "id": "H10-09",
  "kind": "chassis",
  "group": "Économie de tir",
  "name": "Surcharge passive",
  "desc": "burst en début de combat puis tir réduit"
 },
 {
  "id": "H10-10",
  "kind": "chassis",
  "group": "Économie de tir",
  "name": "Mode endurance",
  "desc": "DPS bas mais aucune longue interruption"
 },
 {
  "id": "H11-01",
  "kind": "chassis",
  "group": "Terrain et zones",
  "name": "Patins gris",
  "desc": "mobilité hors combat en gris mais aucun bonus dangereux"
 },
 {
  "id": "H11-02",
  "kind": "chassis",
  "group": "Terrain et zones",
  "name": "Patins verts",
  "desc": "résiste poussée monstres verts mais vie légèrement faible"
 },
 {
  "id": "H11-03",
  "kind": "chassis",
  "group": "Terrain et zones",
  "name": "Coque orange",
  "desc": "résiste monstres orange mais pas joueurs"
 },
 {
  "id": "H11-04",
  "kind": "chassis",
  "group": "Terrain et zones",
  "name": "Coque rouge",
  "desc": "résiste monstres rouges mais vitesse réduite"
 },
 {
  "id": "H11-05",
  "kind": "chassis",
  "group": "Terrain et zones",
  "name": "Ancrage violet",
  "desc": "résiste souffle boss mais aucun bonus dégâts"
 },
 {
  "id": "H11-06",
  "kind": "chassis",
  "group": "Terrain et zones",
  "name": "Explorateur",
  "desc": "vitesse hors combat entre zones mais coup reçu annule"
 },
 {
  "id": "H11-07",
  "kind": "chassis",
  "group": "Terrain et zones",
  "name": "Frontière",
  "desc": "petit bouclier temporaire au passage zone avec long cooldown mais vie faible"
 },
 {
  "id": "H11-08",
  "kind": "chassis",
  "group": "Terrain et zones",
  "name": "Éclaireur-zone",
  "desc": "info danger précise mais aucun gain XP"
 },
 {
  "id": "H11-09",
  "kind": "chassis",
  "group": "Terrain et zones",
  "name": "Routier",
  "desc": "accélération sur trajet long mais virages pénalisants"
 },
 {
  "id": "H11-10",
  "kind": "chassis",
  "group": "Terrain et zones",
  "name": "Stationnaire-zone",
  "desc": "résiste monstres si lent mais pas PvP"
 },
 {
  "id": "H12-01",
  "kind": "chassis",
  "group": "Profils défensifs",
  "name": "Compact",
  "desc": "même hitbox mais décor réduit et vie faible pour vitesse"
 },
 {
  "id": "H12-02",
  "kind": "chassis",
  "group": "Profils défensifs",
  "name": "Cuirassé",
  "desc": "vie forte mais silhouette de décor lourde et lent"
 },
 {
  "id": "H12-03",
  "kind": "chassis",
  "group": "Profils défensifs",
  "name": "Réactif",
  "desc": "résiste premier coup après repos mais suivants plein effet"
 },
 {
  "id": "H12-04",
  "kind": "chassis",
  "group": "Profils défensifs",
  "name": "Ablatif",
  "desc": "absorbe faible part burst plafonné puis recharge longue"
 },
 {
  "id": "H12-05",
  "kind": "chassis",
  "group": "Profils défensifs",
  "name": "Endurant",
  "desc": "résiste dégâts faibles répétés mais gros coups plein effet"
 },
 {
  "id": "H12-06",
  "kind": "chassis",
  "group": "Profils défensifs",
  "name": "Duel défensif",
  "desc": "résiste agresseur principal mais autres plein effet"
 },
 {
  "id": "H12-07",
  "kind": "chassis",
  "group": "Profils défensifs",
  "name": "Fuite",
  "desc": "vitesse sous vie critique avec délai mais dégâts réduits"
 },
 {
  "id": "H12-08",
  "kind": "chassis",
  "group": "Profils défensifs",
  "name": "Gardien de groupe",
  "desc": "petit bonus soi proche alliés sans transfert dégâts mais vitesse moindre"
 },
 {
  "id": "H12-09",
  "kind": "chassis",
  "group": "Profils défensifs",
  "name": "Solitaire",
  "desc": "réparation hors combat loin alliés mais vie max réduite"
 },
 {
  "id": "H12-10",
  "kind": "chassis",
  "group": "Profils défensifs",
  "name": "Dernière plaque",
  "desc": "une réduction sous seuil par vie mais pas invulnérabilité"
 },
 {
  "id": "P01-01",
  "kind": "passive",
  "group": "Précision",
  "name": "Œil fixe",
  "desc": "précision après repos tir mais bonus disparaît au mouvement"
 },
 {
  "id": "P01-02",
  "kind": "passive",
  "group": "Précision",
  "name": "Mémoire cible",
  "desc": "petit bonus suivi continu mais reset changement"
 },
 {
  "id": "P01-03",
  "kind": "passive",
  "group": "Précision",
  "name": "Tir mesuré",
  "desc": "tir espacé renforcé mais cadence limitée"
 },
 {
  "id": "P01-04",
  "kind": "passive",
  "group": "Précision",
  "name": "Épure",
  "desc": "dispersion réduite mais nombre projectiles réduit"
 },
 {
  "id": "P01-05",
  "kind": "passive",
  "group": "Précision",
  "name": "Angle net",
  "desc": "tirs obliques plus précis mais centre moins puissant"
 },
 {
  "id": "P01-06",
  "kind": "passive",
  "group": "Précision",
  "name": "Portée lisible",
  "desc": "indicateur portée plus précis sans révéler cible mais dégâts faibles"
 },
 {
  "id": "P01-07",
  "kind": "passive",
  "group": "Précision",
  "name": "Patience",
  "desc": "charge plus stable mais mouvement lent"
 },
 {
  "id": "P01-08",
  "kind": "passive",
  "group": "Précision",
  "name": "Ligne claire",
  "desc": "bonus si aucune cible traversée mais faible pénétration"
 },
 {
  "id": "P01-09",
  "kind": "passive",
  "group": "Précision",
  "name": "Impact unique",
  "desc": "un projectile fort mais fragments interdits"
 },
 {
  "id": "P01-10",
  "kind": "passive",
  "group": "Précision",
  "name": "Visée froide",
  "desc": "moins chauffe si vise stable mais virages pénalisés"
 },
 {
  "id": "P02-01",
  "kind": "passive",
  "group": "Défense",
  "name": "Prudence",
  "desc": "petit bouclier hors combat mais dégâts faibles"
 },
 {
  "id": "P02-02",
  "kind": "passive",
  "group": "Défense",
  "name": "Repli",
  "desc": "accélération après dégâts avec cooldown mais offensive réduite"
 },
 {
  "id": "P02-03",
  "kind": "passive",
  "group": "Défense",
  "name": "Carapace",
  "desc": "résistance contact mais portée réduite"
 },
 {
  "id": "P02-04",
  "kind": "passive",
  "group": "Défense",
  "name": "Pare-énergie",
  "desc": "résiste premier rayon après repos mais faible contre balles"
 },
 {
  "id": "P02-05",
  "kind": "passive",
  "group": "Défense",
  "name": "Pare-obus",
  "desc": "souffle réduit mais direct accru"
 },
 {
  "id": "P02-06",
  "kind": "passive",
  "group": "Défense",
  "name": "Sang-froid",
  "desc": "contrôles successifs atténués mais vie moindre"
 },
 {
  "id": "P02-07",
  "kind": "passive",
  "group": "Défense",
  "name": "Remise en route",
  "desc": "régénération après fuite plus tôt mais lente"
 },
 {
  "id": "P02-08",
  "kind": "passive",
  "group": "Défense",
  "name": "Survie lente",
  "desc": "vie accrue mais mobilité faible"
 },
 {
  "id": "P02-09",
  "kind": "passive",
  "group": "Défense",
  "name": "Fortin",
  "desc": "résistance immobile mais dégâts artillerie inchangés"
 },
 {
  "id": "P02-10",
  "kind": "passive",
  "group": "Défense",
  "name": "Garde arrière",
  "desc": "protection fuite mais tir frontal moins fort"
 },
 {
  "id": "P03-01",
  "kind": "passive",
  "group": "Chasse PvE",
  "name": "Géomètre",
  "desc": "dégâts formes accrus mais tanks réduits"
 },
 {
  "id": "P03-02",
  "kind": "passive",
  "group": "Chasse PvE",
  "name": "Dompteur",
  "desc": "dégâts monstres accrus mais formes réduits"
 },
 {
  "id": "P03-03",
  "kind": "passive",
  "group": "Chasse PvE",
  "name": "Chasseur colossal",
  "desc": "dégâts boss accrus mais tanks réduits"
 },
 {
  "id": "P03-04",
  "kind": "passive",
  "group": "Chasse PvE",
  "name": "Brise-cristal",
  "desc": "bonus rares formes mais communes moindres"
 },
 {
  "id": "P03-05",
  "kind": "passive",
  "group": "Chasse PvE",
  "name": "Nettoyeur",
  "desc": "bonus monstres faibles mais boss moindre"
 },
 {
  "id": "P03-06",
  "kind": "passive",
  "group": "Chasse PvE",
  "name": "Pisteur",
  "desc": "aggro monstres visible mais vitesse moindre"
 },
 {
  "id": "P03-07",
  "kind": "passive",
  "group": "Chasse PvE",
  "name": "Écorcheur",
  "desc": "pénétration monstres accrue mais dégâts PvP faibles"
 },
 {
  "id": "P03-08",
  "kind": "passive",
  "group": "Chasse PvE",
  "name": "Solide PvE",
  "desc": "résiste monstre contact mais dégâts distance plus élevés"
 },
 {
  "id": "P03-09",
  "kind": "passive",
  "group": "Chasse PvE",
  "name": "Veilleur PvE",
  "desc": "résiste projectile monstre mais contact accru"
 },
 {
  "id": "P03-10",
  "kind": "passive",
  "group": "Chasse PvE",
  "name": "Vétéran PvE",
  "desc": "bonus augmente sur même monstre mais reset rapide"
 },
 {
  "id": "P04-01",
  "kind": "passive",
  "group": "Unités déployées",
  "name": "Chef de meute",
  "desc": "drones groupés renforcés mais dispersés faibles"
 },
 {
  "id": "P04-02",
  "kind": "passive",
  "group": "Unités déployées",
  "name": "Essaim prudent",
  "desc": "drones se replient tôt mais pertes moindres"
 },
 {
  "id": "P04-03",
  "kind": "passive",
  "group": "Unités déployées",
  "name": "Gardien de ruche",
  "desc": "proche tank défend mieux mais portée courte"
 },
 {
  "id": "P04-04",
  "kind": "passive",
  "group": "Unités déployées",
  "name": "Pose réfléchie",
  "desc": "pièges espacés plus résistants mais max moindre"
 },
 {
  "id": "P04-05",
  "kind": "passive",
  "group": "Unités déployées",
  "name": "Mine isolée",
  "desc": "mine éloignée plus forte mais densité faible"
 },
 {
  "id": "P04-06",
  "kind": "passive",
  "group": "Unités déployées",
  "name": "Constructeur",
  "desc": "barrières durent plus mais vie moindre"
 },
 {
  "id": "P04-07",
  "kind": "passive",
  "group": "Unités déployées",
  "name": "Reconstruction prudente",
  "desc": "unités remplacées au repos mais lent en combat"
 },
 {
  "id": "P04-08",
  "kind": "passive",
  "group": "Unités déployées",
  "name": "Tour de garde",
  "desc": "tourelles secondaires proches plus rapides mais dégâts bas"
 },
 {
  "id": "P04-09",
  "kind": "passive",
  "group": "Unités déployées",
  "name": "Lien court",
  "desc": "unités réactives proches mais rayon faible"
 },
 {
  "id": "P04-10",
  "kind": "passive",
  "group": "Unités déployées",
  "name": "Lien stable",
  "desc": "unités endurantes mais reconstruction lente"
 },
 {
  "id": "P05-01",
  "kind": "passive",
  "group": "Rythme combat",
  "name": "Ouverture",
  "desc": "premier tir après long repos renforcé mais cadence basse"
 },
 {
  "id": "P05-02",
  "kind": "passive",
  "group": "Rythme combat",
  "name": "Endurance combat",
  "desc": "chaleur mieux gérée après tir long mais départ faible"
 },
 {
  "id": "P05-03",
  "kind": "passive",
  "group": "Rythme combat",
  "name": "Pause utile",
  "desc": "courtes pauses améliorent prochain tir mais tir continu faible"
 },
 {
  "id": "P05-04",
  "kind": "passive",
  "group": "Rythme combat",
  "name": "Alternance utile",
  "desc": "alternance mouvement/repos stabilise tir mais bonus plafonné"
 },
 {
  "id": "P05-05",
  "kind": "passive",
  "group": "Rythme combat",
  "name": "Dernière rafale",
  "desc": "vie faible augmente cadence mais précision baisse"
 },
 {
  "id": "P05-06",
  "kind": "passive",
  "group": "Rythme combat",
  "name": "Économie froide",
  "desc": "tir peu fréquent chauffe peu mais aucun burst"
 },
 {
  "id": "P05-07",
  "kind": "passive",
  "group": "Rythme combat",
  "name": "Offensive brève",
  "desc": "salve plus rapide mais pause imposée"
 },
 {
  "id": "P05-08",
  "kind": "passive",
  "group": "Rythme combat",
  "name": "Reprise",
  "desc": "après surchauffe premier tir fort mais chauffe vite"
 },
 {
  "id": "P05-09",
  "kind": "passive",
  "group": "Rythme combat",
  "name": "Duel long",
  "desc": "gain limité sur suivi même cible mais reset perte visée"
 },
 {
  "id": "P05-10",
  "kind": "passive",
  "group": "Rythme combat",
  "name": "Escarmouche",
  "desc": "mobilité après cessez-le-feu mais dégâts bas"
 },
 {
  "id": "P06-01",
  "kind": "passive",
  "group": "Spécialisations",
  "name": "Éclaireur",
  "desc": "vitesse hors combat mais vie faible"
 },
 {
  "id": "P06-02",
  "kind": "passive",
  "group": "Spécialisations",
  "name": "Arrière-garde",
  "desc": "tirs défensifs arrière mais front réduit"
 },
 {
  "id": "P06-03",
  "kind": "passive",
  "group": "Spécialisations",
  "name": "Avant-poste",
  "desc": "tir arrêté efficace mais lent à repartir"
 },
 {
  "id": "P06-04",
  "kind": "passive",
  "group": "Spécialisations",
  "name": "Traqueur tank",
  "desc": "dégâts tank légèrement accrus mais PvE faibles"
 },
 {
  "id": "P06-05",
  "kind": "passive",
  "group": "Spécialisations",
  "name": "Protecteur",
  "desc": "protection proche alliés mais DPS réduit"
 },
 {
  "id": "P06-06",
  "kind": "passive",
  "group": "Spécialisations",
  "name": "Rupture",
  "desc": "pénétration accrue mais collision faible"
 },
 {
  "id": "P06-07",
  "kind": "passive",
  "group": "Spécialisations",
  "name": "Équilibriste",
  "desc": "profil sans pic et chaleur stable mais plafond dégâts bas"
 },
 {
  "id": "P06-08",
  "kind": "passive",
  "group": "Spécialisations",
  "name": "Périphérie",
  "desc": "fort proche portée max mais faible proche"
 },
 {
  "id": "P06-09",
  "kind": "passive",
  "group": "Spécialisations",
  "name": "Rapproché",
  "desc": "fort proche mais portée réduite"
 },
 {
  "id": "P06-10",
  "kind": "passive",
  "group": "Spécialisations",
  "name": "Technicien",
  "desc": "effets plus durables mais dégâts directs réduits"
 }
];

export const RAW_PASS: RawPassLevel[] = [
 {
  "level": 1,
  "free": "Emblème Première étincelle",
  "premium": "Bannière Fondateur de saison"
 },
 {
  "level": 2,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 3,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 4,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 5,
  "free": "Jeton ×2",
  "premium": "25 gemmes"
 },
 {
  "level": 6,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 7,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 8,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 9,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 10,
  "free": "Bannière Engrenage",
  "premium": "Effet élimination Pression — premium"
 },
 {
  "level": 11,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 12,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 13,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 14,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 15,
  "free": "Jeton restauration",
  "premium": "25 gemmes"
 },
 {
  "level": 16,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 17,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 18,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 19,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 20,
  "free": "Emblème Rivet",
  "premium": "Effet mort Surchauffe — premium"
 },
 {
  "level": 21,
  "free": "25 gemmes",
  "premium": "Jeton restauration ×2"
 },
 {
  "level": 22,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 23,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 24,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 25,
  "free": "Jeton salon",
  "premium": "25 gemmes"
 },
 {
  "level": 26,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 27,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 28,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 29,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 30,
  "free": "Traînée Cuivre",
  "premium": "Cadre Atelier — premium"
 },
 {
  "level": 31,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 32,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 33,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 34,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 35,
  "free": "Jeton réinitialisation",
  "premium": "25 gemmes"
 },
 {
  "level": 36,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 37,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 38,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 39,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 40,
  "free": "Effet tir Étincelle",
  "premium": "Emblème Noyau — premium"
 },
 {
  "level": 41,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 42,
  "free": "25 gemmes",
  "premium": "Jeton restauration ×2"
 },
 {
  "level": 43,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 44,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 45,
  "free": "Jeton ×5",
  "premium": "25 gemmes"
 },
 {
  "level": 46,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 47,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 48,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 49,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 50,
  "free": "Effet élimination Boulons",
  "premium": "Traînée Forge — premium"
 },
 {
  "level": 51,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 52,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 53,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 54,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 55,
  "free": "Jeton ×2",
  "premium": "25 gemmes"
 },
 {
  "level": 56,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 57,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 58,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 59,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 60,
  "free": "Effet mort Éclatement acier",
  "premium": "Effet tir Pulsation — premium"
 },
 {
  "level": 61,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 62,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 63,
  "free": "25 gemmes",
  "premium": "Jeton restauration ×2"
 },
 {
  "level": 64,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 65,
  "free": "Jeton restauration",
  "premium": "25 gemmes"
 },
 {
  "level": 66,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 67,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 68,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 69,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 70,
  "free": "Bannière Circuit",
  "premium": "Bannière Genèse — premium"
 },
 {
  "level": 71,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 72,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 73,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 74,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 75,
  "free": "Jeton salon",
  "premium": "25 gemmes"
 },
 {
  "level": 76,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 77,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 78,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 79,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 80,
  "free": "Emblème Rouage",
  "premium": "Cadre Maître mécanicien — premium"
 },
 {
  "level": 81,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 82,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 83,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 84,
  "free": "25 gemmes",
  "premium": "Jeton restauration ×2"
 },
 {
  "level": 85,
  "free": "Jeton réinitialisation",
  "premium": "25 gemmes"
 },
 {
  "level": 86,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 87,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 88,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 89,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 90,
  "free": "Traînée Turbine",
  "premium": "Emblème Prototype — premium"
 },
 {
  "level": 91,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 92,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 93,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 94,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 95,
  "free": "Jeton ×5",
  "premium": "25 gemmes"
 },
 {
  "level": 96,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 97,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 98,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 99,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 100,
  "free": "Effet tir Arc bleu",
  "premium": "Collection Armure prototype — premium"
 },
 {
  "level": 101,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 102,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 103,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 104,
  "free": "150 pièces",
  "premium": "300 pièces"
 },
 {
  "level": 105,
  "free": "Collection finale GENÈSE — Acier vivant",
  "premium": "Collection finale GENÈSE — Cœur solaire animé"
 }
];
